export const getUserDataByType = (userType, dataObject) => {
  if (userType === 'LeadBroker') {
    return dataObject?.leadBrokerData
  } else {
    return dataObject?.buyerData
  }
}
